import React, { createRef } from 'react'
import { TextField } from '@mui/material'

interface OtpProps {
    otp: string;
    setOtp: Function
    disabled?: boolean
}

const Otp: React.FC<OtpProps> = ({ otp, setOtp, disabled }) => {
    const ref0 = createRef<HTMLInputElement>()
    const ref1 = createRef<HTMLInputElement>()
    const ref2 = createRef<HTMLInputElement>()
    const ref3 = createRef<HTMLInputElement>()
    const ref4 = createRef<HTMLInputElement>()
    const ref5 = createRef<HTMLInputElement>()

    const isNumeric = (n: string): boolean => {
        return !isNaN(parseFloat(n)) && isFinite(parseFloat(n))
    }

    const handleInputChange = (index: number, event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (disabled) return
        const value = event.target.value
        if (value !== '' && value.length === 1 && isNumeric(value)) {
            setOtp((prevOtp: string) => prevOtp + value)
            if (index < 5) {
                (index === 0 ? ref1 : index === 1 ? ref2 : index === 2 ? ref3 : index === 3 ? ref4 : ref5).current?.focus()
            }
        } else {
            if (value.length > 1) {
                const newOtp = otp.slice(0, index) + value.slice(1, 2) + otp.slice(index + 1)
                setOtp(newOtp)
                if (index < 5) {
                    (index === 0 ? ref1 : index === 1 ? ref2 : index === 2 ? ref3 : index === 3 ? ref4 : ref5).current?.focus()
                }
            } else {
                const newOtp = otp.slice(0, index) + otp.slice(index + 1)
                setOtp(newOtp)
                if (index > 0) {
                    (index === 1 ? ref0 : index === 2 ? ref1 : index === 3 ? ref2 : index === 4 ? ref3 : ref4).current?.focus()
                }
            }
        }
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', borderRadius: 5, justifyContent: 'center' }}>
            {[0, 1, 2, 3, 4, 5].map(index => (
                <TextField
                    autoFocus={index === 0}
                    placeholder="•"
                    inputRef={index === 0 ? ref0 : index === 1 ? ref1 : index === 2 ? ref2 : index === 3 ? ref3 : index === 4 ? ref4 : ref5}
                    inputProps={{ maxLength: 1 }}
                    disabled={disabled}
                    value={otp.slice(index, index + 1)}
                    style={{
                        fontSize: 24,
                        width: 38,
                        height: 40,
                        display: 'flex',
                        alignItems: 'center',
                        justifySelf: 'center',
                        textAlign: 'center',
                        marginRight: 5
                    }}
                    onChange={event => handleInputChange(index, event)}
                />
            ))}
        </div>
    )
}

export default Otp
